import { Button, Flex, Heading, Skeleton, Spacer } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { GenericError } from "src/components/Feedback/GenericError";
import { AdminFormButtons } from "src/components/Layout/AdminFormButtons";
import { RemoteDataView } from "src/components/Layout/RemoteDataView";
import {
  NavigationBlocker,
  NavigationBlockerProvider,
} from "src/components/NavigationBlocker";
import { useAvelaToast } from "src/hooks/useAvelaToast";
import { validateWithZod } from "src/services/formValidations";
import * as Branding from "./Branding";

export const BrandingTab = () => {
  const branding = Branding.useForm();
  const toast = useAvelaToast();
  return (
    <RemoteDataView
      remoteData={branding.initialValues}
      error={() => <GenericError />}
      loading={<Loading />}
    >
      {(initialValues) => {
        return (
          <NavigationBlockerProvider>
            <Formik<Branding.FormikType>
              initialValues={initialValues}
              validate={validateWithZod(Branding.FormikSchema)}
              onSubmit={async (values, formik) => {
                try {
                  await branding.submit(values);
                  toast({
                    title: "Organization updated",
                    isClosable: true,
                    status: "success",
                  });
                  formik.resetForm({ values });
                } catch (error) {
                  console.error(error);
                  toast.error({
                    title: "Error editing organization",
                    description:
                      "Please try again later or report the problem to our support team",
                  });
                }
              }}
            >
              {(formik) => (
                <Flex
                  as={Form}
                  direction="column"
                  height="100%"
                  grow="1"
                  gap={6}
                >
                  <Heading as="h2" variant="admin">
                    Branding
                  </Heading>
                  <Branding.Form />
                  <Spacer />
                  <AdminFormButtons insideTabPanel>
                    <Spacer />
                    <Button
                      type="submit"
                      isLoading={formik.isSubmitting}
                      isDisabled={!formik.dirty || !formik.isValid}
                    >
                      Update
                    </Button>
                    <NavigationBlocker hasChanges={formik.dirty} />
                  </AdminFormButtons>
                </Flex>
              )}
            </Formik>
          </NavigationBlockerProvider>
        );
      }}
    </RemoteDataView>
  );
};

const Loading = () => {
  return (
    <Flex direction="column" gap="6" width="100%">
      <Skeleton height="2rem" width="15rem" />
      <Flex gap="2" width="100%">
        <Flex direction="column" gap="6" width="100%">
          <Flex direction="column" gap="2" width="100%">
            <Skeleton height="2rem" width="10rem" />
            <Skeleton height="6rem" width="20rem" />
            <Skeleton height="3rem" width="6rem" />
          </Flex>
          <Flex direction="column" gap="2" width="100%">
            <Skeleton height="2rem" width="10rem" />
            <Skeleton height="6rem" width="20rem" />
            <Skeleton height="3rem" width="6rem" />
          </Flex>
          <Flex direction="column" gap="2" width="100%">
            <Skeleton height="2rem" width="20rem" />
            <Skeleton height="2rem" width="20rem" />
          </Flex>
        </Flex>
        <Flex direction="column" gap="2" width="100%">
          <Skeleton height="20rem" width="100%" />
        </Flex>
      </Flex>
    </Flex>
  );
};
